import React, { createContext, useState } from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';
// import physics from '../../styles/themes/physics';
import chemistry from '../../styles/themes/chemistry';


type PropsAppThemeContext = {
  theme: DefaultTheme;
  changeTheme: (value: DefaultTheme) => void;
};

const DEFAULT_VALUE = {
  theme: chemistry,
  changeTheme: () => { },
} as PropsAppThemeContext;

const AppThemeContext = createContext<PropsAppThemeContext>(DEFAULT_VALUE);

interface ContextFnProps {
  children: React.ReactNode;
}

function AppThemeContextProvider({ children }: ContextFnProps) {
  const [state, setState] = useState(DEFAULT_VALUE.theme);

  const changeTheme = (value: DefaultTheme) => {
    setState(value);
  }

  return (
    <AppThemeContext.Provider
      value={{
        theme: state,
        changeTheme,
      }}
    >
      <ThemeProvider theme={state}>
        {children}
      </ThemeProvider>
    </AppThemeContext.Provider>
  );
}

export { AppThemeContextProvider };
export default AppThemeContext;
